<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang='scss'>
@import './src/scss/config.imports.scss';

body {
  overflow: hidden;

  &.scroll {
    overflow-y: scroll;
  }
}

#app {
  width: inherit;
  height: inherit;
}

.canvas-bg {
  position: fixed;
  top: 0;
  right: 0;
  /*width: 100%;*/
  /*height: 100%;*/
  z-index: 2;
}

.go-to-section__container {
  float: left;
  @include center(x,fixed,50%);
  bottom: rem(20);
  z-index: 99;
}

button {
  &.go-to-section {
    float: left;
    margin: 0 rem(5);
    font-size: rem(30);

    @include media($media-mobile...) {
      margin: 0 10px;
    }

    &.is--disabled {
      opacity: 0.2;
    }
  }
}

.menu__container {
  position: fixed;
  top: 50%;
  left: 100vw;
  transform: translate(-50%, -50%) rotate(-90deg);
  transform-origin: center center;
  z-index: 99;
  margin-left: rem(-60);
  font-family: $font-family-circular;
  font-weight: 600;

  @include media($media-mobile...) {
    top: 0;
    left: 0;
    transform: translate(0, 0) rotate(0);
    z-index: 0;
    opacity: 0;
    display: none;
    background-color: $overlay;
    opacity: 0.7;
    padding: 0 20px;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  @include media("height<=900px", "width>768px") {
    top: 0;
    left: 0;
    transform: translate(0, 0) rotate(0);
    z-index: 0;
    opacity: 0;
    display: none;
    background-color: $overlay;
    opacity: 0.7;
    padding: 0 20px;
  }

  &.is--active {
    @include media($media-mobile...) {
      z-index: 98;
      display: block;
      margin-left: 0;
    }
    @include media("height<=900px", "width>768px") {
      z-index: 98;
      display: block;
      margin-left: 0;
    }
  }

  ul {
    display: flex;
    flex-direction: row-reverse;
    color: $white;
    font-size: rem(14);
    font-weight: 600;
    justify-content: space-between;

    @include media($media-mobile...) {
      flex-direction: column;
      justify-content: space-around;
      font-size: rem(20);
      margin-top: rem(100);
      text-align: center;
    }
    @include media("<=320px") {
      margin-top: rem(50);
    }
    @include media("height<=800px", "width>768px") {
      font-size: 11px;
    }
    @include media("height<=900px", "width>768px") {
      flex-direction: column;
      justify-content: space-around;
      font-size: rem(24);
      margin-top: rem(100);
      text-align: center;
    }

    li {
      margin: 0 rem(10);
      white-space: nowrap;

      @include media($media-mobile...) {
        white-space: normal;
        margin: rem(10) 0;
        border: none;
      }
      @include media("height<=800px", "width>768px") {
        margin: 0 rem(7);
      }
      @include media("height<=900px", "width>768px") {
        white-space: normal;
        margin: rem(10) 0;
        border: none;
      }

      span {
        padding-bottom: 2px;
        border-bottom: 1px solid $white;
        opacity: 0.5;
      }

      &.is--active {
        span {
          opacity: 1;
        }
      }

      &:hover {
        cursor: pointer;

        span {
          opacity: 1;
        }
      }
    }
  }
}

.video {
  &__seek-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    opacity: 0;

    &.show {
      z-index: 50;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?774c2fa0